import {
    Formik,
    // Field
} from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { RegContainer, RegForms, RegisterSection } from '../components/Authentication/AuthStyles';
import {
    Backbutton,
    HeaderContainer,
} from '../components/LandingPageComponents/styles/HeaderStyles';
import { backbtn } from './dashboard/components/Icons';
import { Box, Heading, Text, Spinner } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../redux/actions/authActions';
import RegForm from 'components/LandingPageComponents/desktop/RegForm';
import InputText from 'components/Input';
import { useScreenWidth } from 'hooks/useScreenWidth';

const ResetPassword = () => {
    const validationSchema = Yup.object().shape({
        otp: Yup.number().required('Enter OTP'),
        password: Yup.string().required('Enter a password'),
        confirm: Yup.string()
            .required('Enter a password')
            .test('passwords-match', 'Passwords must match', function (value) {
                return this.parent.password === value;
            }),
    });

    const initialValues = { password: '', otp: '', confirm: '' };
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const forgotPasswordReducer = useSelector((state) => state.forgotPasswordReducer);
    const resetReducer = useSelector((state) => state.resetReducer);
    const { user, loading } = forgotPasswordReducer;
    const { resetUser } = resetReducer;

    const screen = useScreenWidth();

    let request_id = user?.data?.request_id;

    useEffect(() => {
        if (resetUser) {
            navigate(`/dashboard`);
        }
    }, [resetUser, navigate]);

    return (
        <RegContainer>
            <RegisterSection>
                {screen <= 500 && (
                    <HeaderContainer style={{ padding: 0 }}>
                        <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                    </HeaderContainer>
                )}
                {screen <= 500 && (
                    <Box>
                        <Heading
                            as="h1"
                            fontSize="32px"
                            fontWeight="700"
                            color="#090A0A"
                            mt="0px"
                            mb="8px">
                            Reset Password
                        </Heading>
                        <Text color="#2C2C2C" fontSize="14px" mb="10px">
                            Please enter your new password.
                        </Text>
                    </Box>
                )}
                <RegForm>
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            setSubmitting(true);
                            let data = {
                                request_id,
                                otp: values.otp,
                                password: values.password,
                            };
                            setSubmitting(false);

                            dispatch(resetPassword(data));
                        }}>
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            setFieldTouched,
                        }) => (
                            <div className="form-sect">
                                {screen > 500 && (
                                    <>
                                        <div style={{ padding: '2rem 4rem', float: 'right' }}>
                                            <Link to="/login">
                                                <Text fontSize="16px" fontWeight="500">
                                                    Go Back
                                                </Text>
                                            </Link>
                                        </div>
                                    </>
                                )}
                                <RegForms
                                    style={{ marginTop: screen > 500 ? '30%' : '5%' }}
                                    onSubmit={handleSubmit}>
                                    <div className="border-group">
                                        {screen > 500 && (
                                            <div
                                                style={{
                                                    marginTop: '1rem',
                                                    marginBottom: '2rem',
                                                    textAlign: 'center',
                                                }}>
                                                <Heading
                                                    color="#090A0A"
                                                    fontSize="24px"
                                                    lineHeight="36px">
                                                    Reset Password
                                                </Heading>
                                            </div>
                                        )}
                                        <div className="form-group">
                                            <label htmlFor="otp">OTP</label>
                                            <div>
                                                <input
                                                    type="number"
                                                    placeholder="OTP"
                                                    name="otp"
                                                    onChange={handleChange}
                                                    value={values.otp}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>{' '}
                                        <div className="error-message">
                                            {touched.password && errors.password}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">New Password</label>
                                            <div>
                                                <InputText
                                                    type="password"
                                                    placeholder="****"
                                                    name="password"
                                                    onChange={handleChange}
                                                    value={values.password}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>{' '}
                                        <div className="error-message">
                                            {touched.password && errors.password}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">Confirm New Password</label>
                                            <div>
                                                <InputText
                                                    type="password"
                                                    placeholder="****"
                                                    name="confirm"
                                                    onChange={handleChange}
                                                    value={values.confirm}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>{' '}
                                        <div className="error-message">
                                            {touched.confirm && errors.confirm}
                                        </div>
                                        <hr />
                                        <button
                                            type="submit"
                                            className="sign-in-button"
                                            disabled={loading}>
                                            {!loading ? (
                                                'Submit'
                                            ) : (
                                                <Spinner color="light" size="sm" />
                                            )}
                                        </button>
                                    </div>
                                </RegForms>
                            </div>
                        )}
                    </Formik>
                </RegForm>
            </RegisterSection>
        </RegContainer>
    );
};

export default ResetPassword;
